import InstallMobileOutlinedIcon from '@mui/icons-material/InstallMobileOutlined';
import { Button, Card, CardContent, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { isIosDevice, useInstall } from '@/lib/platform/install';
import { InstallDialog } from './InstallDialog';

/** Install on demand (Profile, Help & support, the landing page); nothing when it's already installed or can't be. */
export function useInstallAction() {
  const install = useInstall();
  const [steps, setSteps] = useState(false);
  const run = async () => {
    if ((await install.install()) === 'instructions') setSteps(true);
  };
  const dialog = <InstallDialog open={steps} context={install.context} onClose={() => setSteps(false)} />;
  return { install, run, dialog };
}

/** A card with the install button, for Profile and Help & support. */
export function InstallAppCard() {
  const { install, run, dialog } = useInstallAction();
  if (!install.available) return null;
  return (
    <Card>
      <CardContent>
        <Stack direction="row" spacing={1.5} sx={{ alignItems: 'flex-start' }}>
          <InstallMobileOutlinedIcon color="primary" sx={{ mt: 0.25 }} />
          <div>
            <Typography variant="h6" sx={{ mb: 0.5 }}>
              Install TradePrep
            </Typography>
            <Typography color="text.secondary" sx={{ mb: 1.5 }}>
              {install.context === 'in-app'
                ? `This window can't install apps. Open the page in ${isIosDevice() ? 'Safari' : "your phone's browser"} to add TradePrep to your home screen.`
                : 'Add it to your home screen to open it full screen, like an app, with no browser bars.'}
            </Typography>
            <Button variant="outlined" onClick={() => void run()}>
              {install.oneTap ? 'Install app' : 'Show me how'}
            </Button>
          </div>
        </Stack>
      </CardContent>
      {dialog}
    </Card>
  );
}

/** A quiet text link for phone visitors on the landing page. */
export function InstallLink() {
  const { install, run, dialog } = useInstallAction();
  if (!install.available || install.context === 'in-app') return null;
  return (
    <>
      <Button size="small" color="inherit" startIcon={<InstallMobileOutlinedIcon />} onClick={() => void run()} sx={{ display: { md: 'none' }, textTransform: 'none', fontWeight: 600 }}>
        Add TradePrep to your home screen
      </Button>
      {dialog}
    </>
  );
}
